import React from 'react'
import styles from './Header.module.css'

const Header = (props) => {
  return (
    <div className='header'>
      {
        props.eventSignupId == null &&
        <p><strong>NO EVENT ID IN THE URL</strong></p>
      }
    </div>
  )
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/Header.js